import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconMinibar: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9 3v4.6l1.7 1.7c.2.2.3.4.3.7v11c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V10c0-.3.1-.5.3-.7L4 7.6V3c0-.6.4-1 1-1h3c.6 0 1 .4 1 1zm0 10H4v2h5v-2zM6 8c0 .3-.1.5-.3.7L4 10.4v.6h5v-.6L7.3 8.7C7.1 8.5 7 8.3 7 8V4H6v4zm-2 9v3h5v-3H4zM22 6v5.5c0 2.1-1.5 3.9-3.5 4.4V20H20c.6 0 1 .4 1 1s-.4 1-1 1h-5c-.6 0-1-.4-1-1s.4-1 1-1h1.5v-4.1c-2-.5-3.5-2.3-3.5-4.4V6c0-.6.4-1 1-1h7c.6 0 1 .4 1 1zm-7 1v4.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V7h-5z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
